import { useEffect } from "react";
import { getReports } from "../../../../../action/masters/reportActionCreator";
import { IYearlyReports } from "../../../../../models/dashboard/staffReports/staffReports";
import { connect, useDispatch } from "react-redux";
import { setReportsYearly } from "../../../../../store/slices/master/reportSlice";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { ReportFrequency } from "../../../../../models/dashboard/adminDashboard";
import { IReports } from "../../../../../models/master/reports";
import { baseURL } from "../../../../../constants/commonConstants";

const StaffAnnuallyReportsViewAll = (props: IYearlyReports) => {
  const { getYearlyReports, yearlyReports } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getYearlyReports(
      pageBlockId.reportResources,
      undefined,
      ReportFrequency.Yearly
    );
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setReportsYearly([]));
    };
  }, []);

  return (
    <>
      <div className="widgets">
        <div className="title">
          <h2>All Monthly and Annual Reports</h2>
        </div>
        <div className="card-wrap">
          <div className="row">
            {yearlyReports?.map((report: IReports) => (
              <div className="report-all-card col-lg-12 mb-2" key={report.id}>
                <div className="card">
                  <div className="img">
                    <img src={baseURL + report.icon} alt="" />
                  </div>
                  <div className="desc">
                    <h3>{report.name}</h3>
                    <p>{report.description}</p>
                    <a
                      href={report.url}
                      target="_blank"
                      className="mt-3 btn-arrow btn-block-arrow"
                    >
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getYearlyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    yearlyReports: state.report.yearlyreports,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffAnnuallyReportsViewAll);
